export const strToBool = (string) =>
  string === "false" ? false : Boolean(string);

export const kebabCase = (string) =>
  string
    .replace(/([a-z])([A-Z])/gu, "$1-$2")
    .replace(/[\s_]+/gu, "-")
    .toLowerCase();

export function handleScreenIncursion(element) {
  if (!element) {
    return;
  }

  // current transform values might interfere with the calculations
  element.style.transform = null;

  const viewportPadding = 20;
  const bounding = element.getBoundingClientRect();

  let xTranslate = 0;

  const rightIncursion = bounding.right - document.documentElement.clientWidth;

  if (rightIncursion > 0) {
    xTranslate = rightIncursion + viewportPadding;
  }

  let yTranslate = 0;

  const bottomIncursion =
    bounding.bottom - document.documentElement.clientHeight;

  if (bottomIncursion > 0) {
    yTranslate = bottomIncursion + viewportPadding;
  }

  const hasScreenIncursion = xTranslate || yTranslate;

  if (hasScreenIncursion) {
    element.style.transform = `translate(-${xTranslate}px, -${yTranslate}px )`;
  }
}
